function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11790",
  "data-name": "Path 11790",
  d: "M16.941,2.118V6.462H34.55V2.118Z",
  transform: "translate(0.828 0.103)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11791",
  "data-name": "Path 11791",
  d: "M0,2.118H4.386V6.5H0Z",
  transform: "translate(0 0.103)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11792",
  "data-name": "Path 11792",
  d: "M0,14.824V19.24H11.13V14.824Z",
  transform: "translate(0 0.724)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11793",
  "data-name": "Path 11793",
  d: "M23.294,14.824v4.4H34.371v-4.4Z",
  transform: "translate(1.138 0.724)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11794",
  "data-name": "Path 11794",
  d: "M0,27.529H17.811v4.358H0Z",
  transform: "translate(0 1.345)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11795",
  "data-name": "Path 11795",
  d: "M29.647,27.529h4.442v4.356H29.647Z",
  transform: "translate(1.448 1.345)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11796",
  "data-name": "Path 11796",
  d: "M23.425,34.385a4.327,4.327,0,0,0,4.46-4.175c0-2.355-2.045-4.8-4.46-4.8a4.492,4.492,0,0,0,0,8.974Z",
  transform: "translate(0.936 1.241)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11797",
  "data-name": "Path 11797",
  d: "M16.939,21.575a4.951,4.951,0,0,0,4.671-4.611c0-2.353-2.332-4.258-4.671-4.258a4.247,4.247,0,0,0-4.233,4.257,4.561,4.561,0,0,0,4.233,4.611Z",
  transform: "translate(0.621 0.621)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11798",
  "data-name": "Path 11798",
  d: "M10.92,8.842a4.64,4.64,0,0,0,4.366-4.585C15.286,1.906,12.963,0,10.61,0A4.258,4.258,0,0,0,6.353,4.258,4.819,4.819,0,0,0,10.92,8.843Z",
  transform: "translate(0.31)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var SvgAdjustmentHorizon = function SvgAdjustmentHorizon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "adjustment-horizon",
    width: 35.537,
    height: 35.627,
    viewBox: "0 0 35.537 35.627",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdjustmentHorizon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adjustment-horizon.9f187ae6.svg";
export { ForwardRef as ReactComponent };